import { render } from "./MainSection.vue?vue&type=template&id=374ed4ec&scoped=true&ts=true"
import script from "./MainSection.vue?vue&type=script&lang=ts"
export * from "./MainSection.vue?vue&type=script&lang=ts"

import "./MainSection.vue?vue&type=style&index=0&id=374ed4ec&scoped=true&lang=scss"

import exportComponent from "/Users/Matt/projects/betherance/betherswap/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374ed4ec"]])

export default __exports__